export const clientProduction = {
    commonMinHeight: 95,
};
